import { get } from "./authenticatedrequestUtil";
import { ProfitAndLossData } from "../../types/ProfitAndLoss";
import { RevenueProfitExpenseResponse } from "../../types/revenueprofitexpenseResponse";

import dayjs, { Dayjs } from "dayjs";

export const getProfitAndLoss = get<ProfitAndLossData>(
  ({ companyId, startDate, endDate }) =>
    `/${companyId}/reports/profit&loss?startDate=${startDate}&endDate=${endDate}`
);

export const getRevenueProfitExpense = get<RevenueProfitExpenseResponse>(
  ({ companyId, month, year }) => {
    // dayjs months are 0-indexed, so we add 1
    return `/${companyId}/reports/revenue-profit-expenses?year=${year}&month=${month}`;
  }
);

import { ProfitAndLossDataYearly } from "../../types/ProfitAndLoss";

export const getProfitAndLossYearly = get<ProfitAndLossDataYearly[]>(
  ({ companyId, year }) => `/${companyId}/reports/profit&loss?year=${year}`
);

